// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "-" + {"12":"90fa3024","175":"a9f65cdf","233":"03e580ad","369":"da6a3812","777":"d85915b3","936":"afc9dcf9"}[chunkId] + ".js";
};